import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import BowlMark from './BowlMark';
import { BRAND, LINKS } from '../brand';
import './Header.css';

const NAV = [
  { id: 'features', label: 'Produit' },
  { id: 'wallet', label: 'Wallet' },
  { id: 'how-to-use', label: 'Comment ça marche' },
  { id: 'contact', label: 'Contact' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    setIsMenuOpen(false);
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      return;
    }
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
            <span className="logo-mark">
              <BowlMark size={22} decorative />
            </span>
            <span className="logo-text">{BRAND.product}</span>
          </Link>
          <nav
            id="site-nav"
            className={`nav ${isMenuOpen ? 'nav-open' : ''}`}
            aria-label="Principal"
          >
            {NAV.map((item) => (
              <a
                key={item.id}
                href={`/#${item.id}`}
                onClick={(event) => scrollToSection(event, item.id)}
              >
                {item.label}
              </a>
            ))}
            <Link to="/privacy" onClick={() => setIsMenuOpen(false)}>
              Confidentialité
            </Link>
            <a
              className="nav-cta"
              href={LINKS.manageCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              Gérer ma carte
            </a>
          </nav>
          <button
            type="button"
            className={`menu-toggle ${isMenuOpen ? 'is-open' : ''}`}
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
            aria-controls="site-nav"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
